import { render } from "./PasswordRecovery.vue?vue&type=template&id=190357a8&bindings={\"isResetSent\":\"data\",\"resetError\":\"data\",\"reset\":\"data\",\"submitRequestReset\":\"options\"}"
import script from "./PasswordRecovery.vue?vue&type=script&lang=js"
export * from "./PasswordRecovery.vue?vue&type=script&lang=js"
script.render = render

export default script